import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import '../OrderSummary.css'
import axios from 'axios';
import GetProductName from '../GetProductName';
import Hubnav from '../Hubnav';
import { useNavigate } from 'react-router-dom';
import toastify from '../../Util/toastify';
import BaseURL from '../../Util/BaseURL';
const HubOrderSummary = () => {
        var temp=0
        const location=useLocation()
        var nav = useNavigate()
        const [products,setProducts]=useState([])
        async function getCartDetails() {
          const r = await axios.get(`${BaseURL}OrderDetails?number=${location.state.orderNo}`, { headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } })
      
          setProducts(r.data)
      }
      
      function productreached(props1, props2){
        axios.post(`${BaseURL}ReachedHub?id=${props1}&pid=${props2}`,{},{headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } })
        toastify("Product Reached Hub","success") 
        nav(0)
      }
      
      function allot(){
          var no=location.state.orderNo
          nav('/DistributionHubPanel/HubOrders/HubOrderSummary/AllotDeliveryBoy', { state: { orderno: no} })
      }
      
      useEffect(() => {
       getCartDetails();
       },[]); 
  return (
      <>
    <Hubnav/>
          <section id="hero">
                <div className="hero-container">
                    <div className="hero-logo">
                        <h1 className="font-weight-bold">Order Summary</h1>
                    </div>
                </div>
           </section>
           <section className="">
               <div className="container">
                   <div className="cart">
                       <div className="table-responsive">
                       <table className="table">
                                <thead className="thead-dark tableH">
                                    <tr>
                                        <th scope="col" className="text-white">Products Wating For Confirmation</th>
                                    </tr>
                                </thead>
                                </table>
                           <table className="table">
                               <thead className="thead-dark tableH">
                                   <tr>
                                      
                                       <th scope="col" className="text-white">Product</th>
                                       <th scope="col" className="text-white">Price</th>
                                       <th scope="col" className="text-white">Quantity</th>
                                       <th scope="col" className="text-white">Total</th>
                                       <th scope="col" className="text-white">Delivery Status</th>
                                   </tr>
                               </thead>
                               <tbody>
                               {products ? products.map((data,key) => (
                                   <tr key={key}>
                                       
                                   {
                                           data.status === 'Dispatached' || data.status === 'Not Dispatched'?<>
                                   <td><GetProductName props={data.product_id} /></td>
                                   <td className="price">{data.price}</td>
                                   <td className='quantity'>{data.quantity}</td>
                                   <td className="total">{data.quantity*data.price}</td>
                                   {
                                       data.status === 'Dispatached'?<>
                                       <td className='status' style={{color:"green"}} onClick={()=>productreached(data.ordernumber,data.product_id)}><b>Dispatched</b></td>
                                       </>:<>
                                       <td className='status' style={{color:"red"}}><b>Not Dispatched</b></td>
                                       </>
                                   }
                                      </>:<></>
                                       }
                                   </tr>
                                    )) : ""}
                               </tbody>
                           </table>
                           <table className="table">
                                <thead className="thead-dark tableH">
                                    <tr>
                                        <th scope="col" className="text-white">Updated Status</th>
                                    </tr>
                                </thead>
                                </table>
                           <table className="table">
                               <thead className="thead-dark tableH">
                                   <tr>
                                       <th scope="col" className="text-white">Product</th>
                                       <th scope="col" className="text-white">Price</th>
                                       <th scope="col" className="text-white">Quantity</th>
                                       <th scope="col" className="text-white">Total</th>
                                       <th scope="col" className="text-white">Delivery Status</th>
                                   </tr>
                               </thead>
                               <tbody>
                               {products ? products.map((data,key) => (
                                   <tr key={key}>
                                       {
                                           data.status === 'Reached Distribution Hub'?<>
                                            <td><GetProductName props={data.product_id} /></td>
                                   <td className="price">{data.price}</td>
                                   <td className='quantity'>{data.quantity}</td>
                                   <td className="total">{data.quantity*data.price}</td>
                                   <td className='status' style={{color:"green"}}><b>{data.status}</b></td>
                                           </>:<></>
                                       }
                                  
                                   
                                   </tr>
                                    )) : ""}
                               </tbody>
                           </table>
                           <button type='button' className='btn btn-success' onClick={()=>allot()}>Allot Delivery Boy</button>
                       </div>
                   </div>
               </div>
               </section>
   </>
  )
}

export default HubOrderSummary